import { render, staticRenderFns } from "./creatAlert.vue?vue&type=template&id=fac6221a&"
import script from "./creatAlert.vue?vue&type=script&lang=js&"
export * from "./creatAlert.vue?vue&type=script&lang=js&"
import style0 from "./creatAlert.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports